module.exports = __webpack_public_path__ + "c30abb1d21b35e0135f1ac64b6c9cc1a.svg";